"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_CONCIERGE_INTIMATION = exports.USER_BASE = exports.VERIFY_EMAIL_OTP = exports.SEND_EMAIL_OTP = exports.SEND_EMAIL = exports.ACN_EXISTS = exports.EMAIL_EXISTS = exports.UPDATE_PRIMARY_EMAIL = exports.GET_USER = exports.UPDATE_PRIMARY_PHONE = exports.GET_EMAIL = exports.CREATE_ACCOUNT = exports.LOCALHOST_URL = exports.SERVER_URL = exports.SortOrder = exports.TrusteeType = exports.EntityType = exports.EmailVerificationResponse = exports.OtpResponseMessage = void 0;
var OtpResponseMessage;
(function (OtpResponseMessage) {
    OtpResponseMessage["OTP_SENT"] = "OTP sent successfully.";
    OtpResponseMessage["OTP_VERIFIED"] = "OTP verified successfully.";
})(OtpResponseMessage || (exports.OtpResponseMessage = OtpResponseMessage = {}));
var EmailVerificationResponse;
(function (EmailVerificationResponse) {
    EmailVerificationResponse["VERIFICATION_CODE_SENT"] = "Successfully sent email verification code.";
    EmailVerificationResponse["EMAIL_VERIFIED"] = "Email verified successfully.";
})(EmailVerificationResponse || (exports.EmailVerificationResponse = EmailVerificationResponse = {}));
var EntityType;
(function (EntityType) {
    EntityType["INDIVIDUAL"] = "individual";
    EntityType["COMPANY"] = "company";
    EntityType["TRUST"] = "trust";
    EntityType["SMSF"] = "smsf";
    EntityType["JOINT"] = "joint";
})(EntityType || (exports.EntityType = EntityType = {}));
var TrusteeType;
(function (TrusteeType) {
    TrusteeType["INDIVIDUAL"] = "individual";
    TrusteeType["COMPANY"] = "company";
})(TrusteeType || (exports.TrusteeType = TrusteeType = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["ASC"] = 1] = "ASC";
    SortOrder[SortOrder["DESC"] = -1] = "DESC";
})(SortOrder || (exports.SortOrder = SortOrder = {}));
// Paths
exports.SERVER_URL = "/api";
exports.LOCALHOST_URL = "http://localhost:4000";
exports.CREATE_ACCOUNT = "/auth/create-account";
exports.GET_EMAIL = "/auth/get-email";
exports.UPDATE_PRIMARY_PHONE = "/user/phones/primary";
exports.GET_USER = "/user/profile";
exports.UPDATE_PRIMARY_EMAIL = "/user/emails/primary";
exports.EMAIL_EXISTS = "/user/emails/exists";
exports.ACN_EXISTS = "/user/acn/exists";
exports.SEND_EMAIL = "/verify/send-email";
exports.SEND_EMAIL_OTP = "/verify/send-email-otp";
exports.VERIFY_EMAIL_OTP = "/verify/verify-email-otp";
exports.USER_BASE = "/user";
exports.COMPANY_CONCIERGE_INTIMATION = "/company/concierge-intimation";
//# sourceMappingURL=constants.js.map